import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeHeroComponent } from '../../components/home/home-hero/home-hero.component';
import { ExclusiveBenefitsComponent } from '../../components/home/exclusive-benefits/exclusive-benefits.component';
import { WeeklyOffersComponent } from '../../components/home/weekly-offers/weekly-offers.component';
import { MoreOffersComponent } from '../../components/home/more-offers/more-offers.component';
import { CashAdvanceComponent } from '../../components/home/cash-advance/cash-advance.component';
import { WhyUnipayComponent } from '../../components/home/why-unipay/why-unipay.component';
import { PhoneAssistanceBannerComponent } from '../../components/home/phone-assistance-banner/phone-assistance-banner.component';
import { FAQBannerComponent } from '../../components/home/faq-banner/faq-banner.component';
import { WhatsappSectionComponent } from '../../components/home/whatsapp-section/whatsapp-section.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HomeHeroComponent,
    ExclusiveBenefitsComponent,
    WeeklyOffersComponent,
    MoreOffersComponent,
    CashAdvanceComponent,
    WhyUnipayComponent,
    PhoneAssistanceBannerComponent,
    FAQBannerComponent,
    WhatsappSectionComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {} 